import { render } from "./CreateShadowTeam.vue?vue&type=template&id=609e99e9"
import script from "./CreateShadowTeam.vue?vue&type=script&lang=js"
export * from "./CreateShadowTeam.vue?vue&type=script&lang=js"

import "./CreateShadowTeam.vue?vue&type=style&index=0&id=609e99e9&lang=css"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__